/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateFileStore } from '../../axios/candidateFileStore'
import type {
	CandidateFileStoreError,
	CandidateFileStorePathParams,
	CandidateFileStoreRequest,
	CandidateFileStoreResponse,
} from '../../types/CandidateFileStore'

export const candidateFileStoreMutationKey = () => [{ url: '/candidates/:candidateId/files' }] as const

export type CandidateFileStoreMutationKey = ReturnType<typeof candidateFileStoreMutationKey>

export type CandidateFileStoreVariables = {
	candidateId: CandidateFileStorePathParams['candidateId']
	data: CandidateFileStoreRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateFileController.php CandidateFileController::store */
export function useCandidateFileStore<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateFileStoreResponse,
		AxiosError<CandidateFileStoreError>,
		CandidateFileStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateFileStoreMutationKey(),
		mutationFn: ({ candidateId, data }: CandidateFileStoreVariables) =>
			candidateFileStore(candidateId, data, config).then(res => res.data),
		...options,
	})
}
